const QUESTIONS=[
  {id:'q1',text:'Do you experience pain or discomfort during sexual intercourse, pelvic exams, or tampon insertion?',
    text_pt:'Você sente dor ou desconforto durante relações sexuais, exames pélvicos ou uso de absorvente interno?',
    opts:[
      {l:'Never',l_pt:'Nunca',s:{r:0}},
      {l:'Sometimes',sub:'Occasional mild discomfort',l_pt:'Às vezes',sub_pt:'Desconforto leve ocasional',s:{r:1}},
      {l:'Often or always',sub:'Frequent pain, sometimes severe',l_pt:'Frequentemente ou sempre',sub_pt:'Dor frequente, às vezes intensa',s:{r:4,flag:'pain'}},
    ]},
  {id:'q2',text:'Do you experience pelvic pain or discomfort in daily life?',sub:'Sitting for long periods, during exercise, or general pelvic area discomfort',
    text_pt:'Você sente dor ou desconforto pélvico no dia a dia?',sub_pt:'Ao ficar sentada por longos períodos, durante exercícios ou desconforto geral na região pélvica',
    opts:[
      {l:'No',l_pt:'Não',s:{r:0}},
      {l:'Mild, occasional',l_pt:'Leve, ocasional',s:{r:1}},
      {l:'Regular or significant pain',l_pt:'Dor regular ou significativa',s:{r:4,flag:'pain'}},
    ]},
  {id:'q3',text:'When you try to let your pelvic floor fully relax and open, what happens?',
    text_pt:'Quando você tenta relaxar e abrir completamente o assoalho pélvico, o que acontece?',
    opts:[
      {l:'I can relax it easily',l_pt:'Consigo relaxar facilmente',s:{r:0}},
      {l:'I think I relax it, but I\'m not sure',l_pt:'Acho que relaxo, mas não tenho certeza',s:{r:1,c:1}},
      {l:'I find it difficult, tight, or uncomfortable',l_pt:'Acho difícil, tenso ou desconfortável',s:{r:4,flag:'relax'}},
      {l:'I don\'t know what that means or where it is',l_pt:'Não sei o que isso significa ou onde fica',s:{r:2,c:2}},
    ]},
  {id:'q4',text:'Do you experience urinary leakage when you cough, sneeze, laugh, or exercise?',
    text_pt:'Você tem escape de urina ao tossir, espirrar, rir ou se exercitar?',
    opts:[
      {l:'Never',l_pt:'Nunca',s:{w:0}},
      {l:'Rarely',l_pt:'Raramente',s:{w:1}},
      {l:'Sometimes',l_pt:'Às vezes',s:{w:2}},
      {l:'Regularly',l_pt:'Regularmente',s:{w:3}},
    ]},
  {id:'q5',text:'Do you experience a sudden, strong urge to urinate that is sometimes hard to control?',
    text_pt:'Você sente uma vontade repentina e forte de urinar, às vezes difícil de controlar?',
    opts:[
      {l:'Never',l_pt:'Nunca',s:{w:0}},
      {l:'Sometimes',l_pt:'Às vezes',s:{w:1}},
      {l:'Regularly',l_pt:'Regularmente',s:{w:2}},
    ]},
  {id:'q6',text:'Do you feel any heaviness, pressure, or a bulging sensation in the pelvic area?',
    text_pt:'Você sente peso, pressão ou sensação de inchaço na região pélvica?',
    opts:[
      {l:'Never',l_pt:'Nunca',s:{w:0,flag_note:'none'}},
      {l:'Occasionally after long days on my feet',l_pt:'Ocasionalmente após dias longos em pé',s:{w:1}},
      {l:'Regularly, including in the morning',l_pt:'Regularmente, inclusive pela manhã',s:{w:2,flag:'prolapse_risk'}},
    ]},
  {id:'q7',text:'When you try to squeeze or lift your pelvic floor, what do you feel?',
    text_pt:'Quando você tenta contrair ou elevar o assoalho pélvico, o que sente?',
    opts:[
      {l:'A clear lift or squeeze',l_pt:'Uma elevação ou contração clara',s:{w:1}},
      {l:'Something weak or I\'m not sure I\'m doing it right',l_pt:'Algo fraco ou não tenho certeza se estou fazendo certo',s:{w:2,c:1}},
      {l:'My whole body tenses or I hold my breath to feel it',l_pt:'Meu corpo inteiro fica tenso ou prendo a respiração para sentir',s:{r:2,c:1}},
      {l:'I feel nothing. I\'m not sure where it is at all.',l_pt:'Não sinto nada. Não sei onde fica.',s:{c:3}},
    ]},
  {id:'q8',text:'Have you given birth vaginally?',
    text_pt:'Você já teve parto vaginal?',
    opts:[
      {l:'No',l_pt:'Não',s:{w:0}},
      {l:'Yes, one birth',l_pt:'Sim, um parto',s:{w:1}},
      {l:'Yes, two or more births',l_pt:'Sim, dois ou mais partos',s:{w:2}},
    ]},
  {id:'q9',text:'Have you had pelvic surgery, a prolapse diagnosis, or a known pelvic floor condition?',
    text_pt:'Você já fez cirurgia pélvica, teve diagnóstico de prolapso ou alguma condição conhecida do assoalho pélvico?',
    opts:[
      {l:'None of these',l_pt:'Nenhuma dessas',s:{flag:'none'}},
      {l:'Yes, pelvic surgery',l_pt:'Sim, cirurgia pélvica',s:{flag:'physio'}},
      {l:'Yes, prolapse or known PF condition',l_pt:'Sim, prolapso ou condição conhecida do AP',s:{flag:'physio_prolapse'}},
    ]},
  {id:'q10',text:'How connected do you feel to your pelvic floor in daily life?',
    text_pt:'Quão conectada você se sente com seu assoalho pélvico no dia a dia?',
    opts:[
      {l:'Very connected, I can feel it',l_pt:'Muito conectada, consigo sentir',s:{w:1}},
      {l:'Somewhat aware of it',l_pt:'Tenho alguma consciência',s:{c:1}},
      {l:'I rarely or never think about it',l_pt:'Raramente ou nunca penso nisso',s:{c:2}},
      {l:'I actively avoid this area due to discomfort or history',l_pt:'Evito ativamente essa região por desconforto ou histórico',s:{r:2,c:1,flag:'history'}},
    ]},
];
export default QUESTIONS;
